export default __webpack_public_path__ + "static/media/burntodeath2.43458e4b.png";